import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { Form } from 'semantic-ui-react';
import { getOption } from '../utils';
import { TASK_STATUSES, TASK_STATUS } from '../../../../constnats/task';
import {
    TaskExecutionInfoType,
    TaskExecutionUpdateSchemaType,
    taskExecutionUpdateSchema,
} from '../../../../schemas/task.schemas';
import { CompanyType } from '../../../../types/company.types';
import AuthService from '../../../../service/auth';
import { ROLES } from '../../../../constnats/user';
import "../form.styles.css"

type TaskExecutionUpdateFormPropsType = {
    execution: Pick<TaskExecutionInfoType, 'id' | 'notes' | 'status' | 'taskId' | 'entityId'>;
    onSave: (data: TaskExecutionUpdateSchemaType) => void;
    onCancel: () => void;
    companies: CompanyType[];
    showCompany?: boolean;
    readOnly?: boolean;
};

function TaskExecutionUpdateForm({
    execution,
    companies,
    onCancel,
    onSave,
    showCompany = true,
    readOnly = false,
}: TaskExecutionUpdateFormPropsType) {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<TaskExecutionUpdateSchemaType>({
        defaultValues: {
            executionId: execution.id,
            notes: execution.notes,
            status: execution.status,
            taskId: execution.taskId,
        },
        resolver: zodResolver(taskExecutionUpdateSchema),
    });

    const onSubmit = handleSubmit((data) => {
        onSave(data);
    });

    //@ts-ignore
    const allowedTasksStatuses = AuthService.hasAnyGlobalRole([ROLES.TASKS_MANAGER_ROLE, ROLES.QA])
        ? TASK_STATUSES
        : TASK_STATUSES.filter((s) => s !== TASK_STATUS.COMPLETED);

    return (
        <Form className='task__form' onSubmit={onSubmit}>
            {showCompany && (
                <Form.Dropdown
                    value={execution.entityId}
                    disabled
                    label="Company"
                    placeholder="Company"
                    selection
                    search
                    options={companies.map((c) => getOption(c.id, c.name))}
                />
            )}

            <Controller
                disabled={readOnly}
                name="status"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Dropdown
                        disabled={readOnly}
                        value={value}
                        onChange={(_, data) => onChange(data.value)}
                        label="Status"
                        placeholder="Status"
                        selection
                        search
                        options={allowedTasksStatuses.map((s) => getOption(s, s))}
                        error={errors.status?.message}
                    />
                )}
            />

            <Controller
                disabled={readOnly}
                name="notes"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.TextArea
                        disabled={readOnly}
                        value={value ?? ''}
                        onChange={(_, data) => onChange(data.value)}
                        label="Notes"
                        error={errors.notes?.message}
                        rows={8}
                    />
                )}
            />

            <Form.Group className="flex flex-justify-space-between">
                <Form.Button disabled={readOnly} primary type="submit">
                    Save
                </Form.Button>
                <Form.Button type="button" onClick={onCancel}>
                    Cancel
                </Form.Button>
            </Form.Group>
        </Form>
    );
}

export default TaskExecutionUpdateForm;
